import React, { forwardRef } from 'react';

import { IconButton } from '@mui/material';
import { AlineTooltip } from 'src/components/generic/AlineTooltip';
import { CrossIcon } from 'src/components/icons/CrossIcon';
import { makeStyles } from 'tss-react/mui';

const LABEL = 'Add files and more';
const ICON_STYLE = { height: 18, width: 18 };

const useStyles = makeStyles()(theme => ({
  button: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.appColors.rule}`,
    borderRadius: 16,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 32,
    minWidth: 32,
    padding: theme.spacing(0.5),
  },
}));

interface AddContextButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/** The round "+" under a markdown editor that opens its mention menu, shared with the chat. */
export const AddContextButton = React.memo(
  forwardRef<HTMLButtonElement, AddContextButtonProps>(function AddContextButton(
    { disabled = false, onClick },
    ref
  ) {
    const { classes } = useStyles();

    return (
      <AlineTooltip arrow placement="top" title={LABEL}>
        <div>
          <IconButton
            ref={ref}
            aria-label={LABEL}
            className={classes.button}
            disabled={disabled}
            onClick={onClick}
          >
            <CrossIcon style={ICON_STYLE} />
          </IconButton>
        </div>
      </AlineTooltip>
    );
  })
);
